<template>
  <div style="margin-top: 20px">
    <div
      style="
        display: flex;
        font-size: 28px;
        height: 70px;
        line-height: 70px;
        border-bottom: 1px solid black;
        background-color: #f7f7f7;
      "
    >
      <div :class="getDetailActive == 1 ? 'gettimeDetail' : ''">
        <div
          @click="getDetailActive = 1"
          :class="getDetailActive == 1 ? 'getDetail' : 'getdetail'"
        >
          交易公告
        </div>
      </div>
      <div :class="getDetailActive == 2 ? 'gettimeDetail' : ''">
        <div
          @click="getDetailActive = 2"
          :class="getDetailActive == 2 ? 'getDetail' : 'getdetail'"
        >
          交易须知
        </div>
      </div>
      <div :class="getDetailActive == 3 ? 'gettimeDetail' : ''">
        <div
          @click="getDetailActive = 3"
          :class="getDetailActive == 3 ? 'getDetail' : 'getdetail'"
        >
          标的展示
        </div>
      </div>
    </div>
    <div
      style="
        text-align: center;
        padding: 20px;
        padding-top: 40px;
        font-size: 24px;
      "
      class="conent"
    >
      <div v-if="getDetailActive == 1">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">交易公告</el-divider>
          </div>
        </div>
        <div class="hetongBox">
          <p style="font-size: 30px; font-weight: 700; text-align: center">
            辉县市农村产权交易公告
          </p>
          <br />
          <p style="text-indent: 2em">
            根据《辉县市农村产权流转交易管理办法》规定，受
            <span style="text-decoration: underline">{{ detail.outname }}</span>
            的委托，辉县市农村产权交易中心组织
            <span style="text-decoration: underline">{{
              detail.projectname
            }}</span>
            （项目编号：
            <span style="text-decoration: underline">{{
              detail.numbering
            }}</span>
            ）项目交易，现将有关事项公告如下：
          </p>
          <p style="text-indent: 2em; font-weight: 700">一、项目概况</p>
          <p style="text-indent: 2em">
            {{ detail.projectname }},位置:东至{{ detail.east }};南至{{
              detail.south
            }};西至{{ detail.west }};北至{{ detail.north }},数量{{
              detail.area + getDictValue(detail.areaUnit, "area_unit")
            }}。现对外{{ getDictValue(detail.rollout, "out_type") }},交易期限{{
              this.detail.outstarttime &&
              this.detail.outstoptime &&
              (
                ((Number(this.detail.outstoptime.split("-")[0]) -
                  Number(this.detail.outstarttime.split("-")[0])) *
                  12 +
                  Number(this.detail.outstoptime.split("-")[1]) -
                  Number(this.detail.outstarttime.split("-")[1]) +
                  Number(
                    (
                      (Number(this.detail.outstoptime.split("-")[2]) -
                        Number(this.detail.outstarttime.split("-")[2])) /
                      30
                    ).toFixed(2)
                  )) /
                12
              ).toFixed(2)
            }}年,价格为{{
              detail.price +
                " 元/年/" +
                getDictValue(detail.areaUnit, "area_unit") || "/"
            }}。
          </p>
          <p style="text-indent: 2em; font-weight: 700">二、时间地点</p>
          <p style="text-indent: 2em">
            （一）报名时间：
            {{ detail.releaseRecord && detail.releaseRecord.applyStartTime }} 至
            {{ detail.releaseRecord && detail.releaseRecord.applyStopTime }}。
          </p>
          <p style="text-indent: 2em">
            （二）本项目只接受在线报名，意向竞价人需在县农村产权交易中心网站注册登陆后，参与网上交易。
          </p>
          <p style="text-indent: 2em">
            （三）资格审核：报名信息提交后，交易中心工作人员对报名信息进行资格审核。审核通过后，方为报名成功。
          </p>
          <p style="text-indent: 2em">
            （四）意向竞价人在报名时间截止前，须采取银行转账或汇款方式交纳投标保证金，并注明事由。投标保证金以到账时间为准，不计利息，超过规定时间后，视为报名失败。
          </p>
          <p style="text-indent: 2em; font-weight: 700">三、竞价方式</p>
          <p style="text-indent: 2em">
            本项目采用在线自由竞价方式，正向竞价确定成交人。向竞价人需正向递增报价。在线自由竞价交易规则：
          </p>
          <p style="text-indent: 2em">
            (一)自由竞价期60分钟,在此期间内，所有参与方可以对意向标的进行多次报价，每次报价不得低于当前最高有效报价，直到在竞价期内不再出现有效报价，则竞价结束。
          </p>
          <p style="text-indent: 2em">
            (二)竞价过程中，系统实时展示当前竞价项目各意向竞价人最新报价、竞价倒计时、报价次数、报价记录等信息。竞价结束后，最高出价者获得成交资格。
          </p>
          <p style="text-indent: 2em">
            (三)农交中心管理员对竞价过程进行监控，如竞价主体、竞价过程是否存在异常。发现异常，管理员可以随时终止竞价，并通知所有参与方。
          </p>
          <p style="text-indent: 2em; font-weight: 700">
            四、交易（竞价）开始时间
          </p>
          <p style="text-indent: 2em">
            {{
              detail.releaseRecord && detail.releaseRecord.biddingStartTime
            }}开始，结束时间为{{
              detail.releaseRecord && detail.releaseRecord.biddingStopTime
            }}结束。
          </p>
          <p style="text-indent: 2em; font-weight: 700">五、标的咨询</p>
          <p style="text-indent: 2em">
            即日起接受咨询，自行看样。联系人：<span>{{ detail.realname }}</span>
          </p>
          <p style="text-indent: 2em">
            联系电话：<span>{{ realPhone || detail.phone }}</span
            ><img
              src="../assets/img/openEye.png"
              style="width: 30px; height: 30px; cursor: pointer"
              @click="checkShowPhone"
            />
          </p>
          <p style="text-indent: 2em">
            意向竞价人应自行到项目现场查勘，向项目发包方咨询，充分了解项目现状,并依据周围环境等因素综合考虑参与竞价，如竞价人忽略此项提醒，风险自担，成交人在成交后应按交易规定办理相关手续，并及时签订合同。
          </p>
          <p style="text-indent: 2em; font-weight: 700">六、注意事项</p>
          <p style="text-indent: 2em">(一)首次参与线上交易注意事项：</p>
          <p style="text-indent: 2em">
            1、意向竞价人请务必确认已在网上平台注册交易账号，且账号已完成实名备案。
          </p>
          <p style="text-indent: 2em">
            2、根据本项目《交易公告》要求，意向竞价人尽早交纳保证金以免影响后续操作。
          </p>
          <p style="text-indent: 2em">
            3、交易开始后，根据项目公告中的交易规则进行出价。
          </p>
          <p style="text-indent: 2em">
            (二)在项目交易过程中，如发现围标、串标等违法违规行为，其保证金予以没收。
          </p>
          <p style="text-indent: 2em">
            (三)特别提醒：意向竞价人可通过手机App或电脑按时上线交易，但要确保网络环境良好。
          </p>
          <p style="text-indent: 2em">
            (四)产权四至及其他事项解释权归{{ detail.outname }}所有。
          </p>
          <p style="text-indent: 2em">{{ detail.outname }}</p>
          <p style="text-indent: 2em">
            联系人：{{
              detail.realname
            }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联系电话：{{
              realPhone || detail.phone
            }}<img
              src="../assets/img/openEye.png"
              style="width: 30px; height: 30px; cursor: pointer"
              @click="checkShowPhone"
            />
          </p>
          <p style="text-indent: 2em; font-weight: 700">七、咨询方式</p>
          <p style="text-indent: 2em">
            网&nbsp;&nbsp;&nbsp;&nbsp;址:&nbsp;&nbsp;&nbsp;http://117.159.15.238:16035/
          </p>
          <p style="text-align: right">辉县市农村产权交易中心</p>
          <p style="text-align: right">
            {{
              detail.releaseRecord &&
              detail.releaseRecord.publicityStartTime.split(" ")[0]
            }}
          </p>
        </div>
      </div>
      <div v-show="getDetailActive == 2">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">交易须知</el-divider>
          </div>
        </div>

        <table style="width: 100%" border="1">
          <tr>
            <th>投标方资格条件</th>
            <td></td>
          </tr>
          <tr>
            <th>报名方式</th>
            <td v-if="!applyWay">
              <p>1、意向受让方首次报名须知：</p>
              <p>
                ①企业法人单位组织须提交加盖公章的《营业执照》复印件等证明主体资格的相关材料以及法定代表人身份证复印件、经办人身份证复印件、授权委托书、公章、法人章等相关材料；
              </p>
              <p>
                ②非企业法人单位须提交以下资料：申请人身份证正反面复印件1份、申请人银行卡正反面复印件1份。
              </p>
              <p>
                2、非首次报名的意向受让方按时根据保证金备注要求交纳交易保证金后即可参与本期竞价。
              </p>
              <p>3、交易中心向意向受让方发放报价账号（长期有效、注意保管）。</p>
              <p>
                4、交易保证金交纳截止日当天17:30前未收到交易账号激活短信的意向受让方，请致电交易中心。
              </p>
            </td>
            <td v-else v-html="applyWay"></td>
          </tr>
          <tr>
            <th>保证金及处理方式</th>
            <td>
              <p style="font-weight: bold">
                1、须交纳的交易保证金金额为人民币{{ detail.deposit + " 元" }}。
              </p>
              <p style="font-weight: bold">
                2、开户行:{{ backCardInfo ? backCardInfo.bankName : "" }}
              </p>
              <p style="font-weight: bold">
                户名:{{ backCardInfo ? backCardInfo.cardName : "" }}
              </p>
              <p style="font-weight: bold">
                账号:{{ backCardInfo ? backCardInfo.cardNo : "" }}
              </p>
              <p>
                须在交纳保证金截止时间前电话通知交易中心已交纳保证金，如未通知或不得参与竞价。
              </p>
              <p>交纳交易保证金要求：</p>
              <p>
                ①交易保证金可选择网上银行转账、手机银行转账、银行柜面转账、线上支付方式提交。
              </p>
              <p>② 交纳交易保证金时，须备注相关信息：</p>
              <p>企业：项目名称+企业名称。例：XX项目XX公司保证金；</p>
              <p>个人：项目名称+姓名。例：XX项目XX保证金；</p>
              <p>
                交易保证金交易截止时间前未正确备注信息的，资格审查不予通过。
              </p>
              <p>
                未成交者的交易保证金交易中心将在交易结束后15个工作日内全额无息返还。
              </p>
              <p>
                ③竞拍人竞买成功后，携带相关资料到交易中心缴纳服务费，在交易中心主持下与出让方签订合同。
              </p>
              <p>
                ④成交人交易保证金作为出让金转入出让方账户，溢价部分向出让方补缴齐。
              </p>
            </td>
          </tr>
        </table>
      </div>
      <div v-show="getDetailActive == 3">
        <div>
          <div class="fengexian1">
            <el-divider content-position="center">标的展示</el-divider>
          </div>
        </div>
        <div class="imgcontent">
          <el-image
            v-for="(item, index) in detail.imgList"
            :key="index"
            style="
              width: 48%;
              height: auto;
              margin-left: 10px;
              margin-bottom: 10px;
            "
            :src="item"
            :preview-src-list="detail.imgList"
          >
          </el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTypeList } from '@/api/交易项目详情'
import { getNewsDetail, getNewslist } from '../api/mian'
import { cityDetail } from '../util/mainOption'
import { getProList } from '../api/交易项目'
import { getPhoneById } from '../api/login'

export default {
  props: {
    detail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    backCardInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isLogin: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      getDetailActive: 1, //项目模块展示
      showPhone: false,
      showRegisternum: false,
      dictList: {
        // 转出方类别
        "out_person_type": [],
        // 招标方式
        "invitation_type": [],
        // 单位
        "area_unit": [],
        // 农地权属
        "land_type": [],
        // 承包方式
        "job_type": [],
        // 项目类型
        "project_area_type": [],
        // 土地性质
        "tdxz_type": [],
        // 转出方式
        "out_type": [],
        // 支付方式
        "pay_type": [],
        // 出价幅度
        "floating_price": [],
        // 是否再次转出
        "yes_no": [],
      },
      // 报名方式 html
      applyWay: "",
      realPhone: "",
    }
  },
  mounted () {
    getNewslist({
      number: '021',
      pageSize: 10,
      pageNum: 1,
      deptId: sessionStorage.getItem('deptId') || cityDetail.deptId,
    }).then(res => {
      res.data.rows.length > 0 && getNewsDetail({ id: res.data.rows[0].id }).then(res => {
        this.applyWay = res.data.data.content
      })
    })
    for (let dictTitle of Object.keys(this.dictList)) {
      getTypeList(dictTitle).then(res => {
        this.dictList[dictTitle] = res.data.data
      })
    }
  },
  methods: {
    // 手机号小眼睛点击事件
    checkShowPhone () {
      if (this.realPhone) return
      if (!localStorage.getItem('token')) {
        this.$message.warning("请登录后查看！")
        return
      }
      getPhoneById({
        id: this.detail.id,
        projectType: 2
      }).then(res => {
        if (res.data.code == 200) {
          this.realPhone = res.data.msg
        }
      })
    },
    formatDate (cellValue) {
      if (cellValue == null || cellValue == "") return ""
      var date = new Date(cellValue)
      var year = date.getFullYear()
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
      var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours()
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()
      return (
        year + "年" + month + "月" + day + "日" + hours + "时" + minutes + "分"
      )
    },
    bigWrite (num) {
      let max = 999999999999.99
      if (Number(num) > max) return "超过函数可接受最大值"
      let unitList = [
        "",
        "拾",
        "佰",
        "仟",
      ]
      let numberList = [
        "零",
        "壹",
        "贰",
        "叁",
        "肆",
        "伍",
        "陆",
        "柒",
        "捌",
        "玖",
      ]
      let decimals = num.toString().split(".")[1]
      num = num.toString().split(".")[0]
      let numToStringRes = ""
      let numSliceList =
        console.log("num.length", num.length)
      if (num.length > 8) {
        numSliceList = {
          "亿": "",
          "万": "",
          "元": "",
        }
        numSliceList["亿"] = num.slice(0, num.length - 8)
        numSliceList["万"] = num.slice(num.length - 8, num.length - 4)
        numSliceList["元"] = num.slice(num.length - 4)
      } else if (num.length > 4) {
        numSliceList = {
          "万": "",
          "元": "",
        }
        numSliceList["万"] = num.slice(0, num.length - 4)
        numSliceList["元"] = num.slice(num.length - 4)
      } else {
        numSliceList = {
          "元": "",
        }
        numSliceList["元"] = num
      }
      for (let j = 0; j < Object.keys(numSliceList).length; j++) {
        num = Number(numSliceList[Object.keys(numSliceList)[j]])
        let stringRes = ""
        for (let i = 0; i < unitList.length; i++) {
          if (num == 0) {
            break
          }
          let yu = Math.floor(num % 10)
          stringRes = (numberList[yu] == "零" ? numberList[yu] : (numberList[yu] + unitList[i])) + stringRes
          num = Math.floor(num / 10)
        }
        while (true) {
          if (stringRes.indexOf("零零") < 0) {
            break
          }
          stringRes = stringRes.replace("零零", "零")
        }
        if (stringRes.slice(stringRes.length - 1) == "零") {
          stringRes = stringRes.substring(0, stringRes.length - 1)
        }
        stringRes += Object.keys(numSliceList)[j]
        numToStringRes += stringRes
      }
      if (decimals.length > 0 && Number(decimals) != 0) {
        decimals = Number(decimals)
        numToStringRes += (numberList[Math.floor(decimals / 10)] ? numberList[Math.floor(decimals / 10)] + "角" : "零") + (numberList[Math.floor(Number(decimals % 10))] == "零" ? numberList[Math.floor(Number(decimals % 10))] + "分" : "")
      }
      while (true) {
        if (numToStringRes.indexOf("壹拾") < 0) {
          break
        }
        numToStringRes = numToStringRes.replace("壹拾", "拾")
      }
      return numToStringRes
    },
    checkShowRegisternum () {
      this.showRegisternum = !this.showRegisternum
    },
    // 获取字典值
    getDictValue (value, dictTitle) {
      if ((value !== 0 && value !== '0') && !value) return "暂无"
      return this.dictList[dictTitle].find((item) => item.dictValue == value) ? this.dictList[dictTitle].find((item) => item.dictValue == value).dictLabel : "暂无"
    },
  },
}
</script>

<style lang="scss" scoped>
.fengexian1 {
  margin: 30px 0 50px 0;
}

.el-divider__text {
  font-size: 36px;
  /* margin-bottom: 40px; */
  color: #f56c6c;
  list-style: armenian;
}
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
.conent > div {
  margin: 10px 0;
}
.gettimeDetail {
  color: #f56c6c;
  font-weight: 600;
}
.getdetail {
  font-size: 24px;
  padding: 0 30px;
  font-weight: 600;
  opacity: 0.5;
  cursor: pointer;
}

.getDetail {
  font-size: 24px;
  padding: 0 30px;
  border-top: 1px solid #f56c6c;
  background-color: white;
  cursor: pointer;
}
.fengexian {
  margin-bottom: 40px;
}

.fengexian >>> .el-divider__text {
  font-size: 36px;
  /* margin-bottom: 40px; */
  color: #f56c6c;
  list-style: armenian;
}
.tableBox {
  display: flex;
}
.left {
  width: 100%;
  text-align: left;
  display: flex;
  max-width: 100%;
  flex-wrap: wrap;
}
.tet {
  border: 1px solid rgb(210, 210, 210);
  /* padding: 30px; */
  margin: 0 !important;
  display: flex;
  width: 50%;
}

.tet1 {
  min-width: 250px;
  max-width: 250px;
  border-right: 1px solid #f3f5f8;
  padding: 20px 20px;
  text-align: center;
  font-weight: 600;
  background-color: #f3f5f8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tet2 {
  padding: 20px 20px;
  width: 685px;
  max-width: 685px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}

.tet3 {
  padding: 20px 20px;
  width: 550px;
  overflow: hidden;
  text-overflow: ellipsis;
}
table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  padding: 0;
  margin: 0;
  height: 100%;
}

table td {
  height: auto;
  text-align: left;
  table-layout: fixed;
  padding: 10px 6px;
  font-size: 20px;
  line-height: 100%;
  color: #000000;
  line-height: 40px;
}

table th {
  width: 15%;
  height: auto;
  text-align: left;
  table-layout: fixed;
  padding: 10px 6px;
  font-size: 20px;
  line-height: 100%;
  color: #000000;
  background: #fafafa;
  font-weight: normal;
}
.hetongBox {
  width: 100%;
  height: auto;
  text-align: start;
  p {
    line-height: 2;
  }
}
</style>